import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import './index.css'
import App from './App'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://c49bd8497ca50a1394f08ebac63f7ce5@o4504594264293376.ingest.us.sentry.io/4508696020385792",
    integrations: [],
    environment: import.meta.env.VITE_ENV_TIER as string
  });
} else {
  console.log('Sentry disabled in development mode');
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
) 